import { Controller } from 'stimulus';
import { ezNotice } from 'lib/modal_helpers';

export default class LicenseSelectorCreditModalController extends Controller {
  static targets = ['proButton', 'freeButton', 'proDownloadButton', 'freeDownloadButton']

  toggleButtons(e) {
    if (!e.target.classList.contains('is-selected')) {
      const selectedButton = document.querySelector('.license-selector-credit-modal__select-btn.is-selected');
      selectedButton.classList.remove('is-selected');
      e.target.classList.add('is-selected');

      document.querySelector('.license-selector-credit-modal__description.is-selected').classList.remove('is-selected');
      document.querySelector(`.license-selector-credit-modal__description--${e.target.dataset.licenseType}`).classList.add('is-selected');
    }
  }

  proDownloadAfter() {
    ezNotice(
      this.proDownloadButtonTarget.dataset.noticetext,
      {
        noticeHeader: this.proDownloadButtonTarget.dataset.noticeheader,
        noticeClass: 'pro-credit-download-notice',
        noticeDuration: 4000,
        modalReplace: true,
        reloadAfter: this.proDownloadButtonTarget.dataset.dlSize === 'original',
      },
    );
  }

  freeDownloadAfter() {
    ezNotice(
      this.freeDownloadButtonTarget.dataset.noticetext,
      {
        noticeHeader: this.freeDownloadButtonTarget.dataset.noticeheader,
        noticeClass: 'free-credit-download-notice',
        noticeDuration: 4000,
        modalReplace: true,
      },
    );
  }
}
